export const FETCH_ASSIGN_TASK_TO_ANOTHER_USER_REQUEST = 'FETCH_ASSIGN_TASK_TO_ANOTHER_USER_REQUEST'
export const FETCH_ASSIGN_TASK_TO_ANOTHER_USER_SUCCESS = 'FETCH_ASSIGN_TASK_TO_ANOTHER_USER_SUCCESS'
export const FETCH_ASSIGN_TASK_TO_ANOTHER_USER_FALUIRE = 'FETCH_ASSIGN_TASK_TO_ANOTHER_USER_FALUIRE'
